<section class="premium-3d-list-page py-5">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-10">
                
                <div class="premium-page-header mb-5 text-center">
                    <h1 class="ultimate-3d-title">{{ inputData.TitleEn }}</h1>
                    <div class="premium-header-divider mx-auto mt-3"></div>
                </div>

                <div *ngIf="!inputData.ShowAttachments || inputData.ShowAttachments.length == 0">
                    <div class="ultimate-3d-card p-5 text-center mx-auto" style="max-width: 400px;">
                        <i class="fa-regular fa-folder-open" style="font-size: 48px; color: #cbd5e1; margin-bottom: 20px;"></i>
                        <h3 style="color: #64748b; font-weight: 600; margin: 0;">No Data Found</h3>
                    </div>
                </div>

                <div class="row g-4 justify-content-center" *ngIf="inputData.ShowAttachments && inputData.ShowAttachments.length > 0">
                    <div class="col-12" *ngFor="let item of inputData.ShowAttachments">
                        <div class="ultimate-3d-card p-4">
                            <div class="row align-items-center">
                                <div class="col-lg-4 col-md-5 mb-4 mb-md-0">
                                    <div class="list-image-wrapper">
                                        <img [src]="item.FilePath" alt="image" />
                                    </div>
                                </div>
                                <div class="col-lg-8 col-md-7 ps-md-4">
                                    <div class="list-content-wrapper">
                                        <div [innerHTML]="inputData.DetailsEn" class="text-secondary"></div>
                                        <div class="publish-date-badge">
                                            <i class="fa-solid fa-calendar-days me-1"></i>
                                            Publish date: {{ inputData.CurrentDate | date:'MMM dd, yyyy' }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</section>
